import { http } from '@frontend/fetch';
import { addLocationHeader } from '../utils/add-location-header';

export type GetStripePaymentMethodIdProps = {
  locationId: string | undefined;
  paymentUuid: string | undefined;
};
export type GetStripePaymentMethodIdResponse = {
  paymentMethodId: string;
};

export const getStripePaymentMethodId = async ({ locationId, paymentUuid }: GetStripePaymentMethodIdProps) => {
  return await http.get<GetStripePaymentMethodIdResponse>(
    `/payments/payments/${paymentUuid}/payment-method`,
    addLocationHeader(locationId ?? '')
  );
};
